import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PAGE } from '@/constants/common';
import moment from 'moment';
import { FormTypes } from '.';
import {
  DisplayFormat,
  FinancialBreakdownDisplayFormat,
  INTEREST_RATE,
  LOAN_TENURE,
} from '@/constants/others/mortgage-loan';

export const initialState = {
  formField: {
    loanFirstRepayment: moment().toISOString(),
    interestRate: INTEREST_RATE.DEFAULT,
    loanTenure: LOAN_TENURE.DEFAULT,
    loanAmount: 0,
  } as FormTypes,
  loading: true,
  from: '' as PAGE | '',
  displayFormat: DisplayFormat.REMAINING,
  isDisplayAll: false,
  financialBreakdownDisplayFormat: FinancialBreakdownDisplayFormat.MONTHLY,
  activeTooltipIndex: Math.round(LOAN_TENURE.DEFAULT / 2),
};

export const othersMortgageLoan = createSlice({
  name: 'othersMortgageLoan',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    reset: () => {
      return initialState;
    },
    updateIsDisplayAll: (state, action: PayloadAction<boolean>) => {
      state.isDisplayAll = action.payload;
    },
    updateDisplayFormat: (state, action: PayloadAction<DisplayFormat>) => {
      state.displayFormat = action.payload;
    },
    updateFinancialBreakdownDisplayFormat: (
      state,
      action: PayloadAction<FinancialBreakdownDisplayFormat>,
    ) => {
      state.financialBreakdownDisplayFormat = action.payload;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    updateActiveTooltip: (state, action: PayloadAction<number>) => {
      state.activeTooltipIndex = action.payload;
    },
  },
  extraReducers: () => {},
});

export const {
  updateDataForm,
  updateIsDisplayAll,
  updateDisplayFormat,
  updateFinancialBreakdownDisplayFormat,
  updateFrom,
  updateActiveTooltip,
  reset,
} = othersMortgageLoan.actions;

export default othersMortgageLoan.reducer;
